exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-details/reports-configuration-details.component.css
// module id = ../../../../../src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-details/reports-configuration-details.component.css
// module chunks = main